import React from "react";
import Answers from "../Answers/Answers";

import "./Styles.css";

const Home = () => {
  return (
    <div className="home">
      <Answers />
    </div>
  );
};

export default Home;
